<div class="bg-blue-100 h-screen">
  <app-sidebar [(isActive)]="isSidebarOpen"></app-sidebar>
  <section class="h-full mx-auto max-w-[1280px] p-2 md:p-4">
    <header class="bg-blue-500 shadow-md rounded-lg p-4 mb-4 w-full relative">
      <button class="absolute cursor-pointer" (click)="toggleSidebar()">
        <fa-icon class="transform inline-block transition-transform duration-500 ease-in-out text-white text-2xl"
          [ngClass]="{
            'rotate-90': isSidebarOpen(),
            'rotate-0': !isSidebarOpen()
          }" [icon]="menuIcon"></fa-icon>
      </button>
      <a routerLink="" class="block mx-auto w-30">
        <img src="/assets/logos/logo-flat-white.svg" alt="Pet Pets Logo" draggable="false" />
      </a>
    </header>
    <main class="pb-2">
      <router-outlet />
    </main>
  </section>
</div>
